var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAskCategorySocialSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#b9e6f6;}.cls-3{mask:url(#mask);}.cls-4,.cls-9{fill:#89c5cc;}.cls-5{fill:#191847;}.cls-10,.cls-11,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-6{fill:#d4a181;}.cls-7{fill:#2f3676;}.cls-8{fill:#69a1ac;}.cls-10{fill-opacity:0.1;}.cls-11{fill-opacity:0.4;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 210.12,
    height: 140,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    className: "cls-1",
    width: 180,
    height: 140
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "previdenza-lavoro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "previdenza-lavoro"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "umbrella"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2-2",
    "data-name": "Mask"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 180,
    height: 140
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "cls-4",
    d: "M165,88.84c12.95-22.73,27.19-23.21,40.27-9.4,2.62,2.54,5.31-.33,4.75-2.89-7.26-34.61-35.14-55.41-64.93-58.63V13.38a8.13,8.13,0,1,0-16.25,0v4.54C99,21.14,71.37,41.94,64,76.55c-.56,2.56,2.16,5.41,4.75,2.89,13.2-14,27.34-13.3,40.27,9.4,1.34,2.41,3.78,2.18,5,0l.38-.66.38-.66c5-8.59,11.21-17.27,22.27-17.27,13.15,0,20.57,13.69,22.54,17.61l.13.26c.18.36.3.61.36.72C161.25,91,163.69,91.25,165,88.84Zm-40.22,46.38a20.33,20.33,0,0,0,20.31-20.31V81.83A12.42,12.42,0,0,0,137,78.38a11.62,11.62,0,0,0-8.13,3.47v33.09a4.06,4.06,0,0,1-7.89,1.34,8.12,8.12,0,1,0-15.31,5.41A20.31,20.31,0,0,0,124.81,135.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Hair-Back",
    className: "cls-5",
    d: "M45,26.25c3.28,0,4.47-3.91,6.33-6.06,1.33-1.54,3.61-1.08,4.28-3.24,1.69-5.41-2.84-9.23-8.74-9.23S37,11.07,36.11,16.09A8.79,8.79,0,0,0,45,26.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.92,15.49c1.66,3.1,1.46,10.94-.68,11.5-.86.22-2.68-.32-4.54-1.44l1.17,8.23H43l2.37-11a7.73,7.73,0,0,1-2.07-5.58C43.72,11.05,52.26,12.4,53.92,15.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-5",
    d: "M54.33,15.51a16.13,16.13,0,0,0-6.08,3.3,1.77,1.77,0,0,0-.84-.2,1.73,1.73,0,0,0-1.76,1.71,1.71,1.71,0,0,0,.35,1,5.51,5.51,0,0,0-.79,2.15c-1.45,0-6.74-5.48-1.47-10.63S56.62,15.08,54.33,15.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Leg",
    className: "cls-5",
    points: "40.69 57.55 51.09 93.99 58.67 120.84 64.2 120.84 56.14 57.55 40.69 57.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.91,57.55c-.24,18.78-1.06,29-1.31,30.73s-4.07,12.56-11.45,32.57h5.73Q45,92.07,46.62,88.28c1.09-2.52,4.47-12.76,9.55-30.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Right-Shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    className: "cls-5",
    d: "M24.64,126l.29-6h6a35.56,35.56,0,0,0,11.18,4.86V126H31.23l-3.72-.57V126Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.89,126l.29-6h6a35.56,35.56,0,0,0,11.18,4.86V126H64.49l-3.73-.57V126Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    className: "cls-6",
    d: "M25.08,49.07l5.05.91q-8.79,17.43-9.42,18.43c-.93,1.5,0,4.21.37,5.64a1.28,1.28,0,0,1-1.58-.75l-.15-.23a1.7,1.7,0,0,0-2.21-.95c-2.4.64-4.41,2.21-6.69.18-.29-.25-.5-1,.43-1.47,2.33-1,5.76-3,6.31-3.77q1.13-1.53,7.89-18Zm41.38,2.79,9.15,6.71a24.39,24.39,0,0,1,6.21,2.5c.39.35.87,1.08-.76,1s-3.35-.18-3.58.37.77,1.22.31,2q-.45.75-4.29-3.75l-9.06-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Back-Arm",
    className: "cls-8",
    d: "M49.94,28.07A72.76,72.76,0,0,0,68.59,52.59a9.78,9.78,0,0,1,3.83.58,1.27,1.27,0,0,1,.81,1.63,1.25,1.25,0,0,1-.8.8l.8.57-2.31,4.71c-9.71-4.84-18.83-8.48-23-16.46-1.12-2.16-1-8.48-1-12.59v-.72c0-.69,0-1.3,0-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-5",
    d: "M36.11,60.11q13.52,1.47,21.28,0c.64-.13.61-2.89.31-3.64C53.07,44.72,50,36.13,50,28c-.85.44-2.34.51-4.46.2C39.86,36.58,37.23,46.22,36.11,60.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Front",
    className: "cls-9",
    d: "M46.53,27.48c-1,12.68,12.29,40.37,7.69,64-8.51,1.89-20.66-4-32.48.71C22,86.74,25,80.73,28.17,74.71l.68-1.29a86.8,86.8,0,0,0,5.58-11.93,1.29,1.29,0,0,1-.4-1l0-.13h0l.14-.84a1.29,1.29,0,0,1,1.12-1.06c.1-.43.18-.86.25-1.28.58-3.58-.41-7.09-.36-10.54Q28.28,52.51,22.79,67h0l-5.41-1.59c.2-.77.42-1.53.64-2.28-.63-.35-1.36-2-.83-2.25a6.15,6.15,0,0,1,1.72-.59q7.45-22.41,24.36-32.78h3.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shade-Lapel",
    className: "cls-10",
    points: "44.45 27.77 42.97 32.31 45.95 35.72 43.26 38.4 49.77 49.53 41.81 38.42 44.45 35.72 41.81 32.71 44.45 27.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Buttons",
    className: "cls-11",
    d: "M49.58,64.71a1.15,1.15,0,1,1-1.15,1.15A1.16,1.16,0,0,1,49.58,64.71Zm-.29-6.58a1.15,1.15,0,1,1-1.14,1.14A1.14,1.14,0,0,1,49.29,58.13Zm-1.43-6.59a1.15,1.15,0,1,1-1.15,1.15A1.15,1.15,0,0,1,47.86,51.54Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskCategorySocialSecurity);
export default __webpack_public_path__ + "static/media/ask-category-social_security.65090c81a5c079b1e03cca292113e14c.svg";
export { ForwardRef as ReactComponent };